<style lang="less">
.area-price-container {
  width: 750px;
  height: 100%;
  background: #f7f7f7;
  font-family: PingFangSC-Semibold;
  .detail-header {
    position: relative;
    width: 750px;
    height: 400px;
    background-image: url("../../assets/img/buss-background.png");
    background-repeat: no-repeat;
    background-size: cover;
    .return-box {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 24px;
      top: 36px;
      display: flex;
      align-items: center;
      z-index: 9999;
    }
    .header-return {
      width: 36px;
      height: 36px;
    }
    .return-box-ipx {
      width: 100px;
      height: 100px;
      position: absolute;
      display: flex;
      align-items: center;
      left: 24px;
      top: 84px;
      z-index: 9999;
    }
    .header-img {
      width: 750px;
      height: 400px;
    }
    .header-img-ipx {
      width: 750px;
      height: 448px;
    }
    .charts-gauge {
      width: 100%;
      height: 90%;
    }
    .header-info {
      width: 750px;
      color: #232c37;
      position: absolute;
      top: 300px;
      left: 0;
      z-index: 1222;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .header-info-text {
        height: 36px;
        font-size: 26px;
        font-weight: 500;
        color: rgba(35, 44, 55, 1);
        line-height: 36px;
        margin-right: 8px;
      }
      .header-info-img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .detail-main {
    padding: 0 16px;
    background: #f7f7f7;
    width: 718px;
    position: absolute;
    left: 0;
    top: 360px;
    .score-distribution {
      width: 670px;
      height: 600px;
      padding: 24px;
      position: relative;
      .charts-radar {
        width: 100%;
        height: 90%;
      }
    }
    .trend-center-content {
      padding: 24px;
      width: 670px;
      height: 500px;
      margin-top: 18px;
      position: relative;
      .charts-bar {
        width: 100%;
        height: 93%;
      }
    }
    .detail-traffic {
      margin-top: 18px;
      padding: 24px 24px 0;
      .shu {
        width: 2px;
        background: #efefef;
        height: 28px;
      }
      .item {
        height: 36px;
        font-size: 26px;
        font-weight: 400;
        line-height: 36px;
      }
      .apartment {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
      }
      .renovation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
      }
      .rent-trend-line {
        // position: relative;
        // left: -30px;
        width: 100%;
        height: 500px;
        .price-price{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .detail-footer {
    height: 102px;
    line-height: 102px;
    text-align: center;
    color: #BDC3CE;
    // color: rgba(49, 45, 45, 1);
    font-size: 26px;
  }
.title {
  font-size: 32px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(35, 44, 55, 1);
  line-height: 44px;
  text-align: left;
}
.subhead {
  height: 36px;
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  color: #232c37;
  line-height: 36px;
  text-align: left;
}
.footer-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .footer-right-img {
    width: 22px;
    height: 22px;
  }
  .footer-right-text {
    height: 36px;
    font-size: 26px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(65, 105, 225, 1);
    line-height: 36px;
    margin-right: 4px;
  }
}
.common-box-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 34px 32px;
  .common-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .common-title {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(137, 147, 159, 1);
      line-height: 36px;
      margin-bottom: 10px;
    }
    .common-info {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      line-height: 44px;
    }
  }
}
.main-wrapper {
  background: #fff;
  width: 670px;
  box-shadow: 0px 0px 4px 0px rgba(219, 219, 219, 0.5);
  border-radius: 6px;
}
.van-popup {
  border-radius: 8px;
  width: 560px;
}
.popup-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 22px 38px 40px;
  .dialog-title {
    height: 44px;
    font-size: 32px;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    margin: 16px 0;
    font-weight: bold;
  }
  .dialog-info {
    text-align: left;
    font-size: 28px;
    color: rgba(111, 120, 132, 1);
    line-height: 40px;
  }
}
.modal-btn-wrapper {
  display: flex;
  flex-direction: row;
  height: 100px;
  line-height: 100px;
  border-top: 2px solid rgba(7, 17, 27, 0.1);
  background: #fff;
}
.confirm-btn {
  flex: 1;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 32px;
}
.selected {
  color: #4169e1;
  border: none;
}
.noselect {
  color: rgba(137, 147, 159, 1);
}
#price_map {
  width: 100%;
  height: 308px;
  margin-top:20px;
  margin-bottom:34px;
}
}
</style>
<template>
  <div class="area-price-container">
    <div class="detail-header">
      <!-- <div :class="isIpx?'return-box-ipx':'return-box'" @click="returnPre">
        <img class="header-return" src="../../assets/img/return.png">
      </div> -->
      <!-- <e-charts score="{{score}}"></e-charts> -->
      <Gauge class="charts-gauge" id="price-gauge" :score="score"></Gauge>
      <div class="header-info">
        <div class="header-info-text">{{zoneDetail.zoneName}}商圈得分</div>
        <img class="header-info-img" @click="lookScore" src="../../assets/img/wenhao.png">
      </div>
    </div>
    <div class="detail-main">
      <div class="score-distribution main-wrapper">
        <div class="title">各评分项分布</div>
        <Radar class="charts-radar" id="price-radar" :radarData="zoneDetail"></Radar>
      </div>
      <div class="trend-center-content main-wrapper">
        <div class="title">商圈评分月度走势</div>
        <Bar class="charts-bar" :xData="trendInfo.months" :yData="trendInfo.scores"></Bar>
      </div>
      <div class="detail-traffic main-wrapper">
        <div class="title">量价分析</div>
        <div class="common-box-wrapper">
          <div class="common-box">
            <div class="common-title">月租金</div>
            <div class="common-info">{{zoneDetail.unitRentPrice}}元/平米</div>
          </div>
          <div class="common-box">
            <div class="common-title">挂牌量</div>
            <div class="common-info">{{zoneDetail.houseNum}}</div>
          </div>
          <div class="common-box">
            <div class="common-title">挂牌周期</div>
            <div class="common-info">{{zoneDetail.activeDate}}天</div>
          </div>
          <!-- <div class="common-box">
            <div class="common-title">本月新增</div>
            <div class="common-info">{{zoneDetail.houseIncrement}}</div>
          </div> -->
        </div>
        <div class="subhead">挂牌房源分布</div>
        <!-- <map
                    id="myMap1"
                    style="width: 100%; height: 308px;margin-top:34px;margin-bottom:34px;"
                    latitude="{{latitude}}"
                    longitude="{{longitude}}"
                    markers="{{markers}}"
                    show-location
                    scale="{{scale}}"
                    wx:if="{{showMap}}"
                >
                    <div class="mask-map"></div>
        </map>-->
        <div id="price_map"></div>
        <div class="subhead">租金走势</div>
        <div class="apartment">
          <div class="subhead">户型</div>
          <div class="shu"></div>
          <div
            class="apartment-info"
            @click="selectApartment(index)"
            v-for="(item,index) in apartmentList"
            :key="index"
          >
            <div class="item" :class="selectIndex==index?'selected':'noselect'">{{item}}</div>
          </div>
        </div>
        <!-- <div class="renovation">
                  <div class="subhead">装修</div>
                  <div class="shu"></div>
                  <div class="renovation-info" @click="selectSub" data-index="{{index}}" wx:for="{{renovationList}}" wx:key="{{index}}">
                    <div class="item {{selectIndex1==index?'selected':'noselect'}}" data-index="{{index}}">{{item}}</div>
                  </div>
        </div>-->
        <div class="rent-trend-line" ref="price-line">
          <div ref="price-price" class="price-price"></div>
          <!-- <ec-canvas id="mychart-dom-line" canvas-id="mychart-line" ec="{{ ec }}" bind:init="echartInit"></ec-canvas> -->
        </div>
      </div>
      <div class="detail-footer">更新时间：{{rentInfo.updateTime}}</div>
    </div>
    <van-popup v-model="showDialog">
      <div class="popup-box">
        <div class="dialog-title">选址评分</div>
        <div
          class="dialog-info"
        >选址评分是业务团队深入了解合作商家，进行实地探访，将其在长租行业的选址经验整合沉淀、量化各类信息维度，经算法分析形成的结果。选址评分主要通过对城市配套和市场表现两个方面进行评估，满分为100分，得分越高，越适合长租公寓运营商收房选址。</div>
        <div class="dialog-title">评分维度说明</div>
        <div
          class="dialog-info"
        >城市配套是指区域范围内的居住条件，包括内部小区品质、周边的交通、生活配套，以及企业和职工密集度等市场表现是指该区域的租房市场体量、实际需求量，和长租市场发展潜力等</div>
      </div>
      <div class="modal-btn-wrapper">
        <div class="confirm-btn" style="color:#4169E1" @click="confirmPopup">知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
let timestampStart, timestampEnd;
var map;
import Bar from "@/components/echarts_bar";
import Radar from "@/components/echarts_radar";
import Gauge from "@/components/echarts_gauge";
import { Popup } from "vant";
export default {
  name: "price",
  components: {
    Bar,
    Radar,
    Gauge,
    "van-popup": Popup
  },
  data() {
    return {
      isIpx: false,
      showDialog: false,
      latitude: 39.908823,
      longitude: 116.397454,
      scale: 12,
      apartmentList: ["1居", "2居", "3居", "4居","5居"],
      renovationList: ["全部", "简装", "中等", "精装", "豪装"],
      trendInfo: {},
      rentInfo: {},
      markers: [], //挂牌房源分布
      score: 0,
      zoneId: 0,
      cityId: 0,
      zoneDetail: {},
      selectAp: 0,
      selectSub: 0,
      isShare: 0,
      ec: {},
      selectIndex: 2,
      selectIndex1: 0,
      showMap: false,
      timer: ''
    };
  },
  computed: {},
  created() {
    timestampStart = new Date().getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '商圈量价分析'
    });
    let options = this.$route.query;
    this.zoneId = options.zoneId;
    this.cityId = options.cityId;
    this.latitude = options.latitude;
    this.longitude = options.longitude;
    // this.isShare = options.isShare ? options.isShare : 0;
    this.getZoneAvgScoreTrend();
    this.getRentTrend(1);
    this.getHouseDis();
    this.getZoneDetail();
  },
  mounted() {
    this.onReachBottom(e=>{
      this.addBuried({
        source:'1',
        eventType: '触底事件',
        eventContent: '商圈量价分析'
      });
    });
    map = new BMap.Map("price_map");
    var point = new BMap.Point(this.longitude, this.latitude);
    map.centerAndZoom(point, 14);
    map.disableDragging();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
  },
  methods: {
    //返回上个页面
    returnPre() {
      if (this.isShare == 0) {
        wx.navigateBack({
          delta: 1
        });
      } else {
        wx.reLaunch({
          url: "/pages/home/index"
        });
      }
    },
    //查看评分标准
    lookScore() {
      this.addBuried({
        source:'1',
        eventType: '点击事件',
        eventContent: '查看评分标准'
      });
      this.showDialog = true;
    },
    confirmPopup() {
      this.showDialog = false;
    },
    //选择户型
    selectApartment(index) {
      this.selectIndex = index;
      this.getRentTrend(2, { ap: index+1 });
    },
    //选择装修
    // selectSub(e){
    //   this.selectIndex1 = e.target.dataset.index;
    //   this.getRentTrend(3,{sub:e.target.dataset.index})
    // },
    //获取商圈详情信息
    async getZoneDetail() {
      let userId = localStorage.getItem("userId")
      await this.$axios
        .post("api/xz/zone/sum/", {
          zoneId: this.zoneId,
          cityId: this.cityId,
          uuid: localStorage.getItem('uuid'),
          userId: userId?userId:''
        })
        .then(res => {
          if (res.success) {
            this.zoneDetail = res.result;
            this.score = res.result.score;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //商圈得分走势
    getZoneAvgScoreTrend() {
      this.$axios
        .post("api/xz/score/trend/", {
          zoneId: this.zoneId
        })
        .then(res => {
          if (res.success) {
            this.trendInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //商圈租金走势
    getRentTrend(type, selected) {
      let param;
      if (type == 1) {
        param = {
          zoneId: this.zoneId,
          cityId:this.cityId,
          roomNum:3
        };
      } else {
        if (type == 2) {
          this.selectAp = selected.ap;
        } else {
          this.selectSub = selected.sub;
        }
        if (this.selectAp == 0 && this.selectSub == 0) {
          param = {
            zoneId: this.zoneId,
            cityId:this.cityId
          };
        } else if (this.selectSub == 0) {
          param = {
            zoneId: this.zoneId,
            cityId:this.cityId,
            roomNum: this.selectAp
          };
        } else if (this.selectAp == 0) {
          param = {
            zoneId: this.zoneId,
            cityId:this.cityId,
            decoration: this.selectSub
          };
        } else {
          param = {
            zoneId: this.zoneId,
            cityId:this.cityId,
            decoration: this.selectSub,
            roomNum: this.selectAp
          };
        }
      }
      this.$axios
        .post("api/xz/rent/trend/", param)
        .then(res => {
          if (res.success) {
            this.rentInfo = res.result;
            this.createLine();
            // if (type == 1) {
            //   this.timer = setTimeout(() => {
            //     this.initChart(this.canvas, this.width, this.height, this.env);
            //   }, 1000);
            // } else {
            //   this.initChart(this.canvas, this.width, this.height, this.env);
            // }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    addMonth(date, num) {
      // num = parseInt(num);
      var sDate = this.dateToDate(date);

      var sYear = sDate.getFullYear();
      var sMonth = sDate.getMonth() + 1;
      var sDay = sDate.getDate();

      var eYear = sYear;
      var eMonth = sMonth + num;
      var eDay = sDay;
      while (eMonth > 12) {
        eYear++;
        eMonth -= 12;
      }

      var eDate = new Date(eYear, eMonth - 1, eDay);

      while (eDate.getMonth() != eMonth - 1) {
        eDay--;
        eDate = new Date(eYear, eMonth - 1, eDay);
      }

      return eDate;
    },
    dateToDate(date) {
      var sDate = new Date();
      if (typeof date == "object" && typeof new Date().getMonth == "function") {
        sDate = date;
      } else if (typeof date == "string") {
        var arr = date.split("-");
        if (arr.length == 3) {
          sDate = new Date(arr[0] + "-" + arr[1] + "-" + arr[2]);
        }
      }

      return sDate;
    },
    //创建line图表
    createLine() {
      let dom = this.$refs["price-price"];
      let myChart = this.$echarts.init(dom);
      var timestamp = Date.parse(new Date());
      var date = new Date(timestamp);
      //获取年份
      var Y = date.getFullYear();
      //获取月份
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var currentMonth = Y + "-" + M;
      let self = this;

      function getNewDate(_dateObject, x) {
        if (
          _dateObject == null ||
          undefined == _dateObject ||
          _dateObject == ""
        ) {
          _dateObject = new Date();
        }
        _dateObject.setMonth(_dateObject.getMonth() + x);

        //返回日期的毫秒表示
        var nd = _dateObject.valueOf();
        nd = new Date(nd);

        var y = nd.getFullYear();
        var m = nd.getMonth() + 1;
        var d = nd.getDate();

        if (m <= 9) m = "0" + m;
        if (d <= 9) d = "0" + d;
        var cdate = y + "-" + m;

        return cdate;
      }
      let pastSixDate = getNewDate(date, -5);
      function getMonth(num) {
        let date1 = new Date(self.addMonth(date, num));
        let year = date1.getFullYear();
        let month = date1.getMonth() + 1;
        return year + "-" + (month < 10 ? "0" + month : month);
      }
      let pastSix = [
        pastSixDate,
        getMonth(1),
        getMonth(2),
        getMonth(3),
        getMonth(4),
        getMonth(5)
      ];
      let option = '';
      let lineHeight = this.$refs['price-line'].clientHeight;
      let lineWidth = this.$refs['price-line'].clientWidth;
      option = {
        title: {
          show: false
        },
        grid: {
          top: "25%",
          left: "15%",
          right: "10%",
          bottom: "10%",
          containLabel: false,
          height: lineHeight*0.5,
          width: lineWidth*0.8,
        },
        color: ["#4169E1", "#F5A623"],
        legend: {
          data: ["整租", "合租"],
          top: 20,
          left: "right",
          backgroundColor: "#fff",
          z: 100
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle:{
              type:'dashed'
            }
          },
          // formatter:'{b0}<br />整租: {c0}元/㎡<br />合租: {c1}元/㎡'
          formatter:function(params){
      　　　var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
                i === 2 ? relVal += '<br/>' +params[i].marker+ params[i].seriesName+ ':' + params[i].value +" 元/㎡" : relVal += '<br/>' +params[i].marker+ params[i].seriesName+ ':'  + params[i].value+" 元/㎡";
            }
            return relVal;
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data:
            this.rentInfo.months.length != 0 ? this.rentInfo.months : pastSix,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            fontSize: 13,
            rotate: 30
          }
        },
        yAxis: {
          type: "value",
          boundaryGap: false,
          axisLabel: {
            interval: 0,
            fontSize: 13,
            formatter: function(value) {
              if (value >= 10000) {
                return value / 10000 + "万";
              } else if (value >= 1000 && value < 10000) {
                return value / 1000 + "千";
              } else {
                return value;
              }
            }
          },
          // x: 'center',
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          data: ["0", "2千", "4千", "6千", "8千", "1万"],
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: "整租",
            type: "line",
            smooth: true,
            data:
              this.rentInfo.wholes.length != 0
                ? this.rentInfo.wholes
                : [0, 0, 0, 0, 0, 0]
          },
          {
            name: "合租",
            type: "line",
            smooth: true,
            data:
              this.selectIndex == 0?[]:this.rentInfo.sublets.length != 0
                ? this.rentInfo.sublets
                : [0, 0, 0, 0, 0, 0]
          }
        ]
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    //挂牌房源分布
    getHouseDis() {
      this.$axios
        .post("api/xz/house/heatmap/", {
          zoneId: this.zoneId
        })
        .then(res => {
          if (res.success) {
            let points = res.result;
            for (let i = 0; i < points.length; i++) {
              points[i].lat = points[i].latitude;
              points[i].lng = points[i].longitude;
            }
            if (!isSupportCanvas()) {
              alert(
                "热力图目前只支持有canvas支持的浏览器,您所使用的浏览器不能使用热力图功能~"
              );
            }
            let heatmapOverlay;
            heatmapOverlay = new BMapLib.HeatmapOverlay({ radius: 20 });
            map.addOverlay(heatmapOverlay);
            heatmapOverlay.setDataSet({ data: points, max: 100 });
            //是否显示热力图
            heatmapOverlay.show();
            function setGradient() {
              var gradient = {};
              var colors = document.querySelectorAll("input[type='color']");
              colors = [].slice.call(colors, 0);
              colors.forEach(function(ele) {
                gradient[ele.getAttribute("data-key")] = ele.value;
              });
              heatmapOverlay.setOptions({ gradient: gradient });
            }
            //判断浏览区是否支持canvas
            function isSupportCanvas() {
              var elem = document.createElement("canvas");
              return !!(elem.getContext && elem.getContext("2d"));
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  destroyed() {
    timestampEnd = new Date().getTime();
    let residenceTime = timestampEnd - timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '商圈量价分析页停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/market_price/index.vue